// extracted by mini-css-extract-plugin
export default {"gallery":"OfferImage_gallery__fzlDh","modal":"OfferImage_modal__73gHy","modalImage":"OfferImage_modalImage__Ge44O","clsBtn":"OfferImage_clsBtn__sjWiY"};